import React from 'react';
import MaterialIcon from '@/components/MaterialIcon';
import SmartLink from '@/components/SmartLink';

/**
 * RegisterFeaturesSection組件
 * 试用期间可体验的功能展示
 *
 * 显示3个核心功能卡片
 */
export const RegisterFeaturesSection: React.FC = () => {
  return (
    <div className="w-full px-4 md:px-10 lg:px-40 py-16 bg-solution-bg">
      <div className="max-w-[1000px] w-full mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-solution-text mb-4">トライアルで体験できる機能</h2>
          <p className="text-solution-text-secondary">14日間、全機能を制限なくご利用いただけます</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Feature Card 1 */}
          <div className="bg-white rounded-xl p-6 border border-solution-border hover:shadow-lg hover:border-solution-orange/30 transition-all">
            <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center mb-4">
              <MaterialIcon name="map" className="text-2xl text-orange-600" />
            </div>
            <h3 className="font-bold text-solution-text mb-2">フロアマップ・ナビ</h3>
            <p className="text-sm text-solution-text-secondary">現在地から目的地までの最短ルートを3Dマップで案内</p>
          </div>

          {/* Feature Card 2 */}
          <div className="bg-white rounded-xl p-6 border border-solution-border hover:shadow-lg hover:border-solution-orange/30 transition-all">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
              <MaterialIcon name="support_agent" className="text-2xl text-blue-600" />
            </div>
            <h3 className="font-bold text-solution-text mb-2">FAQ・施設案内AI</h3>
            <p className="text-sm text-solution-text-secondary">よくある質問をAIが自動対応、スタッフは接客に集中</p>
          </div>

          {/* Feature Card 3 */}
          <div className="bg-white rounded-xl p-6 border border-solution-border hover:shadow-lg hover:border-solution-orange/30 transition-all">
            <div className="w-12 h-12 rounded-full bg-grape-100 flex items-center justify-center mb-4">
              <MaterialIcon name="mic" className="text-2xl text-grape-600" />
            </div>
            <h3 className="font-bold text-solution-text mb-2">リアルタイム会話</h3>
            <p className="text-sm text-solution-text-secondary">10言語以上に対応、話しかけるだけでAIが案内</p>
          </div>
        </div>

        {/* CTA to main page */}
        <div className="mt-10 text-center">
          <SmartLink
            to="/solution#core-features"
            className="inline-flex items-center gap-2 text-solution-orange font-medium hover:underline"
          >
            <span>機能の詳細を見る</span>
            <MaterialIcon name="arrow_forward" className="text-lg" />
          </SmartLink>
        </div>
      </div>
    </div>
  );
};

export default RegisterFeaturesSection;
